module.exports = __webpack_public_path__ + "static/media/persons-grey.bfbea222.svg";